import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M10.9651 15.515C11.3361 15.515 11.6351 15.214 11.6351 14.844V8.07704C11.6351 7.80604 11.4721 7.56204 11.2211 7.45804C10.9721 7.35404 10.6821 7.41104 10.4921 7.60304L8.05308 10.034C7.79108 10.295 7.79008 10.72 8.05108 10.982C8.31208 11.244 8.73708 11.243 8.99908 10.984L10.2961 9.69204V14.844C10.2961 15.215 10.5961 15.515 10.9661 15.515H10.9651Z"
      fill="currentColor"
    />
    <path
      d="M9.67198 5.407H12.979C13.873 5.407 14.6 4.681 14.6 3.79V2.67C14.6 2.299 14.299 2 13.929 2C13.559 2 13.258 2.3 13.258 2.67V3.791C13.258 3.943 13.132 4.068 12.977 4.068H9.67098C9.29998 4.068 9.00098 4.368 9.00098 4.738C9.00098 5.108 9.29998 5.408 9.67098 5.408L9.67198 5.407Z"
      fill="currentColor"
    />
    <path
      d="M19.7959 6.31505C19.4829 6.11905 19.0679 6.21805 18.8739 6.53205C18.6789 6.84705 18.7749 7.26005 19.0909 7.45505C19.1579 7.49705 19.2309 7.58205 19.2309 7.69305V19.3251C19.2309 20.0611 18.6259 20.6601 17.8819 20.6601H7.07892C6.95892 20.6601 6.87392 20.5881 6.83392 20.5191C6.64692 20.2001 6.23492 20.0911 5.91692 20.2821C5.59792 20.4691 5.49092 20.8801 5.67892 21.1991C5.96992 21.6931 6.50592 22.0011 7.07892 22.0011H17.8819C19.3649 22.0011 20.5719 20.8001 20.5719 19.3241V7.69105C20.5729 7.13805 20.2759 6.61005 19.7969 6.31405L19.7959 6.31505Z"
      fill="currentColor"
    />
    <path
      d="M15.14 19.335C16.62 19.335 17.824 18.134 17.824 16.658V5.68598C17.824 4.79298 17.096 4.06798 16.201 4.06798C15.831 4.06798 15.53 4.36798 15.53 4.73798C15.53 5.10798 15.831 5.40798 16.201 5.40798C16.356 5.40798 16.483 5.53298 16.483 5.68598V16.659C16.483 17.395 15.881 17.994 15.14 17.994H6.11396C5.37296 17.994 4.76896 17.395 4.76896 16.659V5.68598C4.76896 5.53398 4.89596 5.40898 5.05196 5.40898H6.46995C7.36395 5.40898 8.09096 4.68298 8.09096 3.79198V2.67098C8.09096 2.29998 7.79096 2.00098 7.42096 2.00098C7.05096 2.00098 6.74996 2.29998 6.74996 2.67098V3.79198C6.74996 3.94398 6.62396 4.06898 6.46896 4.06898H5.05196C4.15696 4.06898 3.42896 4.79498 3.42896 5.68598V16.66C3.42896 18.135 4.63296 19.337 6.11396 19.337H15.141L15.14 19.335Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Calendar');

export default Icon;
